import {
  getCompany as invokeGetCompany,
  getCompanyForAnonymous as invokeGetCompanyForAnonymous
} from "common/functions/api/companies";
import { useAutoReducer } from "common/functions/reducers";
import { handleError } from "common/functions/utilities";
import { Company } from "graphql/API";
import { useEffect } from "react";
import useSWR from "swr";

export const useCompanyQueryHooks = (
  companyId: string | null | undefined,
  setFatal: ((error?: string | null | undefined) => void) | undefined,
  forAnonymous: boolean | null | undefined = false
) => {
  const [company, initializeCompany, forceCompany, setCompany] =
    useAutoReducer<Company>({} as Company);

  const { data, error, isLoading } = useSWR(
    `company of ${companyId} ${(forAnonymous ?? false) ? "anonymous" : "authenticated"}`,
    async () => {
      // 業者取得
      if (forAnonymous ?? false) {
        return invokeGetCompanyForAnonymous(companyId).then((value) => {
          if (value?.getCompanyForAnonymousF) {
            return {
              ...value.getCompanyForAnonymousF,
              __typename: "Company"
            } as Company;
          }

          return null;
        });
      } else {
        return invokeGetCompany(companyId).then((value) => {
          if (value?.getCompany) {
            return {
              ...value.getCompany,
              __typename: "Company"
            } as Company;
          }

          return null;
        });
      }
    }
  );

  useEffect(() => {
    if (error) {
      handleError(
        error,
        setFatal,
        `業者(${companyId})を取得できませんでした。`
      );
    }
  }, [companyId, error, setFatal]);

  useEffect(() => {
    if (data) {
      forceCompany(data);
    }
  }, [data, forceCompany]);

  return {
    company,
    initializeCompany,
    forceCompany,
    setCompany,
    isLoading,
    error
  } as const;
};
